<template>
  <div class="copy-container">
    <div class="copy-title">
      <input
        type="text"
        :value="url"
        readonly
        v-on:focus="$event.target.select()"
        ref="myinput"
      >
      <a
        href="javascript:void(0)"
        @click.prevent="copyUrl"
        >Copy</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UrlCopy',
  props: ['url'],
  methods: {
    copyUrl() {
      this.$refs.myinput.select();
      document.execCommand('copy');
      notify('Copied to clipboard', 'Copied to clipboard');
    },
  },
};
</script>

<style scoped>
.copy-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.copy-title {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #a7a7a7;
  border-radius: 20px;
  padding: 5px 10px;
  background-color: var(--color-grayish);
}

.copy-title input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background-color: transparent;
  color: #aeb2bd;
  padding: 5px 10px;
  border-radius: 20px;
}

.copy-title input::placeholder {
  color: #aeb2bd;
}

.copy-title a {
  margin-left: 10px;
  color: #aeb2bd;
  text-decoration: none;
  font-size: 14px;
  background-color:  var(--color-blue);;
  border-radius: 20px;
  padding: 3px 20px;
}
</style>
